import React, { useState, useEffect, useRef } from 'react';
import { ChatWindow } from './ChatWindow';

export const IslamicChat: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isMinimized, setIsMinimized] = useState(false);
  const chatButtonRef = useRef<HTMLButtonElement>(null);

  const toggleChat = () => {
    setIsOpen(!isOpen);
    setIsMinimized(false);
  };

  // Fermer le chat si on clique en dehors
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        isOpen &&
        chatButtonRef.current &&
        !chatButtonRef.current.contains(event.target as Node) &&
        !(event.target as HTMLElement).closest('.islamic-chat-window')
      ) {
        // Ne pas fermer si on clique dans la fenêtre de chat
        return;
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  // Raccourci clavier Ctrl+K ou Cmd+K pour ouvrir/fermer
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if ((e.ctrlKey || e.metaKey) && e.key === 'k') {
        e.preventDefault();
        toggleChat();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isOpen]);

  const minimizeChat = () => {
    setIsMinimized(true);
  };

  const maximizeChat = () => {
    setIsMinimized(false);
  };

  return (
    <>
      {/* Bouton flottant avec icône IA/Robot */}
      <button
        ref={chatButtonRef}
        onClick={toggleChat}
        className={`fixed bottom-4 right-4 sm:bottom-6 sm:right-6 z-50 w-14 h-14 sm:w-16 sm:h-16 rounded-full bg-gradient-to-br from-green-500 via-emerald-500 to-teal-600 shadow-2xl flex items-center justify-center text-white transition-all duration-300 transform hover:scale-110 hover:shadow-3xl hover:from-green-400 hover:via-emerald-400 hover:to-teal-500 ${
          isOpen ? 'scale-90 opacity-0 pointer-events-none' : 'scale-100 opacity-100'
        }`}
        aria-label="Ouvrir HanafiyaAI"
        title="💬 Parlez avec HanafiyaAI - Assistant IA pour l'Islam"
      >
        {/* Icône Robot/IA moderne */}
        <svg
          className="w-8 h-8 sm:w-9 sm:h-9"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          {/* Tête du robot */}
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2zM9 9h6v6H9V9z"
          />
          {/* Yeux du robot */}
          <circle cx="10" cy="11" r="1" fill="currentColor" />
          <circle cx="14" cy="11" r="1" fill="currentColor" />
        </svg>
        {/* Badge de notification AI */}
        <span className="absolute -top-1 -right-1 w-6 h-6 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full flex items-center justify-center text-xs font-bold animate-pulse shadow-lg">
          🤖
        </span>
      </button>

      {/* Fenêtre de chat */}
      {isOpen && (
        <ChatWindow
          isMinimized={isMinimized}
          onClose={toggleChat}
          onMinimize={minimizeChat}
          onMaximize={maximizeChat}
        />
      )}
    </>
  );
};

